/**
 * I am about 90% sure this is no longer used. At some point this should be checked, and removed if necessary
 * TODO remove this component
 */
import { useEffect } from 'react';
import { RouteComponentProps } from '@reach/router';
import { PolicyStreamPageContainer } from './components/PageContainer';
import Button from '@mui/material/Button';
import { usePolicyStreamGoogleAnalytics } from '../../hooks/usePolicyStreamGoogleAnalytics';
import {
  GAEventNames,
  EventActions,
} from '../../hooks/usePolicyStreamGoogleAnalytics/types';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
// @ts-expect-error
import CardContent from '@mui/material/CardContent';
import { styled } from '@mui/material';
import { Link } from '@reach/router';
import { useSelector } from 'react-redux';
import { getRecommendation } from '../../store/policystreamStore';
import { policyStreamPaths } from './policyStreamConstants';
import { PolicyStreamLayout } from './components';
import { getPolicyStreamClientAgeYears } from '../../store/utility/policyStreamUtility';
import { MIN_AGE, MAX_AGE } from './constants';
import { PolicyStreamInvalidAge } from './components/PolicyStreamInvalidAge';
import { PolicyStreamLifeInsuranceNotRecommended } from './components/PolicyStreamLifeInsuranceNotRecommended';
import {
  MissingInformation,
  useMissingBasicInfoGuard,
  useMissingRecommendationFormGuard,
} from './components/MissingInformation';

interface PolicyStreamRecommendationsDisplayPageProps
  extends RouteComponentProps {}
export const PolicyStreamRecommendationsDisplayPage = (
  _props: PolicyStreamRecommendationsDisplayPageProps,
) => {
  const myAnalytics = usePolicyStreamGoogleAnalytics();

  const recommendation = useSelector(getRecommendation);
  const clientAge = useSelector(getPolicyStreamClientAgeYears);
  const missingInfo = useMissingBasicInfoGuard();
  const missingRecommendationForm = useMissingRecommendationFormGuard();

  // Send Google Analytics event on component load
  useEffect(() => {
    myAnalytics?.triggerEvent(
      GAEventNames.Recommendations,
      EventActions.PageLoad,
      'PolicyStream Recommendations Page',
    );
  }, [myAnalytics]);

  return (
    <PolicyStreamLayout>
      {missingInfo || missingRecommendationForm ? (
        <MissingInformation
          missing={
            missingInfo
              ? missingInfo.missing
              : missingRecommendationForm
              ? missingRecommendationForm.missing
              : 'Recommendation Form'
          }
          redirectURL={
            missingInfo
              ? policyStreamPaths.baseInformation.url
              : policyStreamPaths.personalize.url
          }
          stepName='Needs Analysis'
        />
      ) : (
        <PolicyStreamPageContainer>
          <h2>Recommendations</h2>
          {clientAge !== null &&
          (clientAge < MIN_AGE || clientAge > MAX_AGE) ? (
            <PolicyStreamInvalidAge />
          ) : !recommendation?.coverageAmountDollars ||
            !recommendation?.policyLengthYears ? (
            <>
              <Typography>
                You don't have any recommendations yet. You can browse the plans
                directly, or go back to get a personalized recommendation.
                Getting the right amount is important - too much or too little
                could cause problems down the road. We highly recommend getting
                a tailored suggestion to help you make the best choice!
              </Typography>
              <ButtonContainer sx={{ mt: 1 }}>
                <Button
                  variant='contained'
                  component={Link}
                  to={policyStreamPaths.personalize.url}
                >
                  Get Recommendation
                </Button>
                <Button
                  variant='contained'
                  component={Link}
                  to={policyStreamPaths.planSelection.url}
                >
                  View Plans
                </Button>
              </ButtonContainer>
            </>
          ) : recommendation.coverageAmountDollars <= 0 ? (
            <PolicyStreamLifeInsuranceNotRecommended />
          ) : (
            <>
              <RecommendationsContainer>
                <Typography variant='body1'>
                  Based on your responses, we recommend the following term
                  length and coverage amount for your insurance plan:
                </Typography>
                <RecommendationTypography gutterBottom>
                  <strong>Term Length:</strong>{' '}
                  {recommendation.policyLengthYears} years
                </RecommendationTypography>
                <RecommendationTypography gutterBottom>
                  <strong>Coverage Amount:</strong> $
                  {recommendation.coverageAmountDollars.toLocaleString()}
                </RecommendationTypography>
              </RecommendationsContainer>

              <ButtonContainer sx={{ mt: 1 }}>
                <Button
                  variant='contained'
                  component={Link}
                  to={policyStreamPaths.baseInformation.url}
                >
                  Back to Info
                </Button>
                <Button
                  variant='contained'
                  component={Link}
                  to={policyStreamPaths.planSelection.url}
                >
                  See Quotes
                </Button>
              </ButtonContainer>
            </>
          )}
        </PolicyStreamPageContainer>
      )}
    </PolicyStreamLayout>
  );
};

const RecommendationsContainer = styled(Card)(({ theme }) => {
  return {
    padding: theme.spacing(2),
    boxShadow: theme.spacing(2),
  };
});

const ButtonContainer = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(3),
  };
});

const RecommendationTypography = styled(Typography)(({ theme }) => {
  return {
    ...theme.typography.body1,
    fontSize: '2rem',
  };
});
